import { Colors, Lightning, Router } from "@lightningjs/sdk";

import {MENU_WIDTH, PAGES} from "../../lib/utils";
import theme from "../../lib/theme";
import { SettingsInfoList } from "./components/Settings/SettingsInfoList";

const githubSha = process.env.APP_GITHUB_SHA || "";
interface InfoTemplateSpec extends Lightning.Component.TemplateSpec {
    Page: {
        Content: {
            List: typeof SettingsInfoList;
            GithubSha?: object;
        };
    };
}

interface InfoTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export class InfoPage
    extends Lightning.Component<InfoTemplateSpec, InfoTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<InfoTemplateSpec>
{
    static override _template(): Lightning.Component.Template<InfoTemplateSpec> {
        return {
            Page: {
                collision: true,
                w: theme.layout.w,
                h: theme.layout.h,
                y: 52,
                x: MENU_WIDTH + theme.layout.content.x,
                flex: { direction: "column", justifyContent: "flex-start", alignItems: "flex-start" },
                Content: {
                    collision: true,
                    w: 1000,
                    flex: { direction: "column" },
                    List: {
                        color: Colors(theme.colors.bg.secondary).get(),
                        rect: true,
                        collision: true,
                        type: SettingsInfoList,
                        w: theme.settings.w,
                        signals: {
                            handleHover: "_setInfoState"
                        }
                    },
                    GithubSha: {
                        visible: !!githubSha,
                        text: {
                            text: githubSha ? `Git SHA: ${githubSha}` : "",
                            fontSize: 20,
                            textColor: Colors(theme.colors.text.secondary).get(),
                            textAlign: "left"
                        }
                    }
                }
            }
        };
    }

    readonly Page = this.getByRef("Page")!;
    readonly Content = this.Page.getByRef("Content")!;
    readonly List = this.Content.getByRef("List")!;
    readonly GithubSha = this.Content.getByRef("GithubSha");

    override _getFocused() {
        return this.List;
    }

    override _handleLeft() {
        // Mirror MovieSingle pattern — Left from a content page returns focus
        // to the Menu sidebar. Without this Lightning Router crashes trying to
        // resolve the focus path on Info / Settings / etc.
        Router.focusWidget("Menu");
    }

    override _firstActive() {
        this.application.emit("clearBackground");
        this.application.emit("setActivePage", PAGES.info.name);
        // Update GitHub SHA visibility and text if available
        if (this.GithubSha) {
            if (githubSha) {
                // Position below the List component
                const listY = this.List.y || 0;
                const listHeight = this.List.h || 0;
                (this.GithubSha as any).patch({
                    y: listY + listHeight + 40,
                    visible: true,
                    text: {
                        text: `Commit ID: ${githubSha}`
                    }
                });
            } else {
                (this.GithubSha as any).patch({
                    visible: false
                });
            }
        }
    }

    override _inactive() {
        this.stage.gc();
    }
}
